/** 攻略英文文案 */
export default {
  1: {
    title: "Mount Fuji Travel Guide",
    intro: "Must-see spots in Tokyo, Osaka, and Kyoto for first-time visitors to Japan.",
    content: `<p><strong style="color:#c00000">Japan Travel Guide | Tokyo, Osaka & Kyoto Highlights</strong></p>
<p>First time in Japan? Save this list of top attractions across Tokyo, Osaka, and Kyoto.</p>
<p><strong>Tokyo</strong></p>
<p>• Senso-ji Temple – Tokyo's oldest temple</p>
<p>• Shinjuku – neon-lit nightlife and shopping</p>
<p>• Ginza – upscale shopping district</p>
<p><strong>Osaka</strong></p>
<p>• Shinsaibashi – major shopping area</p>
<p>• Dotonbori – iconic food street</p>
<p>• Universal Studios Japan – Hollywood-themed park</p>
<p>• Osaka Castle – landmark and cherry blossom spot</p>
<p><strong>Kyoto</strong></p>
<p>• Kiyomizu-dera – classic temple views</p>
<p>• Fushimi Inari – famous red torii gates</p>
<p>• Kinkaku-ji (Golden Pavilion)</p>
<p><strong>Nearby</strong></p>
<p>• Nara Park • Uji matcha • Arima Onsen • Kamakura • Hakone</p>
<p><em>Contact us for customized Japan itineraries.</em></p>`,
  },
  2: {
    title: "Medog Hidden Gem Travel Guide",
    intro: "Essential safety tips for self-driving the Sichuan-Tibet Highway (Route 318).",
    content: `<p><strong style="color:#c00000">Route 318 Self-Drive: Hazards You Should Know</strong></p>
<p>Many travelers dream of driving the Sichuan-Tibet Highway. Inexperienced drivers should not go unprepared—weather, road conditions, and altitude pose real challenges.</p>
<p><strong>Key risks</strong></p>
<p>• Black ice – slow down on marked sections</p>
<p>• Rockfall – pass vulnerable zones quickly</p>
<p>• Snow – use chains and avoid travel in heavy snow</p>
<p>• Large trucks – yield and keep safe distance</p>
<p>• Never overtake on blind curves</p>
<p><strong>Not confident driving?</strong> Join our guided convoy with experienced leaders, oxygen and medical kits, quality hotels, and insurance included.</p>
<p><em>Contact us for Route 318 group and self-drive packages.</em></p>`,
  },
  3: {
    title: "Xinjiang Nalati Travel Guide",
    intro: "Real travel impressions from Xinjiang's grasslands, lakes, and mountain routes.",
    content: `<p><strong style="color:#c00000">Why You Should Visit Xinjiang</strong></p>
<p>From Sayram Lake to the Nalati grasslands, from Xiate Ancient Path to the Pamir Plateau—Xinjiang offers landscapes you will never forget.</p>
<p><strong>Recommended route highlights</strong></p>
<p>（1）S101 Highway & Anjihai Grand Canyon</p>
<p>（2）Sayram Lake loop – the "last tear of the Atlantic"</p>
<p>（3）Xiate Ancient Path for hiking and snow mountain views</p>
<p>（4）Qiongkushitai & Nalati grasslands</p>
<p>（5）Bayinbuluke – Nine Turns of the Yellow River</p>
<p>（6）Bosten Lake – the "West Sea" of Northern Xinjiang</p>
<p><em>Contact us for customized Xinjiang itineraries.</em></p>`,
  },
};
